import MainLayout from "../components/layout/MainLayout";
import { Card, CardContent } from "../components/ui/card";
import { Link } from "react-router-dom";
import { Wallet, Server, FileSpreadsheet, CreditCard } from "lucide-react";

export default function AccountingPage() {
  const pages = [
    {
      title: "Upcoming Renewals",
      description: "Live tracking of SaaS, domain, hosting, and ESP renewals via Pleo, GoDaddy, and Cloudflare.",
      icon: <CreditCard size={24} />,
      path: "/accounting/renewals",
      color: "bg-indigo-50 text-indigo-600 border-indigo-200",
      hoverColor: "hover:border-indigo-400 hover:shadow-md",
    },
    {
      title: "Bilag & Invoice Matcher",
      description: "Automated invoice downloader, Excel matcher, and green report generator for accountant Jesper.",
      icon: <FileSpreadsheet size={24} />,
      path: "/accounting/invoices",
      color: "bg-emerald-50 text-emerald-600 border-emerald-200",
      hoverColor: "hover:border-emerald-400 hover:shadow-md",
    },
    {
      title: "ESP Costs",
      description: "Track monthly costs and renewal dates for all email service providers.",
      icon: <Server size={24} />,
      path: "/accounting/esp",
      color: "bg-blue-50 text-blue-600 border-blue-200",
      hoverColor: "hover:border-blue-400 hover:shadow-md",
    },
  ];

  return (
    <MainLayout>
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-indigo-100 rounded-lg">
            <Wallet size={24} className="text-indigo-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Accounting</h1>
            <p className="text-sm text-gray-500 mt-0.5">
              Financial overview and cost tracking
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {pages.map((page) => (
            <Link key={page.path} to={page.path}>
              <Card
                className={`border transition-all cursor-pointer ${page.color} ${page.hoverColor}`}
              >
                <CardContent className="p-6">
                  <div className="flex items-start gap-4">
                    <div className="p-2 rounded-lg bg-white/70">{page.icon}</div>
                    <div>
                      <h3 className="font-semibold text-gray-900">{page.title}</h3>
                      <p className="text-sm text-gray-600 mt-1">{page.description}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}
